import { render, staticRenderFns } from "./ProdutosCadastro.vue?vue&type=template&id=71f2c8aa&scoped=true&"
import script from "./ProdutosCadastro.vue?vue&type=script&lang=js&"
export * from "./ProdutosCadastro.vue?vue&type=script&lang=js&"
import style0 from "./ProdutosCadastro.vue?vue&type=style&index=0&id=71f2c8aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f2c8aa",
  null
  
)

export default component.exports